<div *ngIf="isHaveOPCFailure != null" class="row status-row">
  <div class="col-8 status-title float-left">{{ 'opc.statusInformation' | translate }}</div>
  <div class="col-4 status-icon float-right" [ngClass]="{
    'status-failure': isHaveOPCFailure === true,
    'status-operational': isHaveOPCFailure !== true
  }">
    {{ isHaveOPCFailure ? ('general.inactive' | translate) : ('general.active' | translate) }}
    <em class="fas fa-circle"></em>
  </div>
</div>